<template>
  <div class="relative right-0 h-full flex items-center justify-center bg-gray-100">
    <div class="text-center p-8">
      <h2 class="text-2xl font-bold mb-4">Instagram</h2>
      <p class="mb-6">Opening Instagram profile...</p>
      <a 
        :href="instagramUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="inline-block px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded hover:from-purple-600 hover:to-pink-600 transition-colors"
      >
        Open Instagram Profile
      </a>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const instagramUrl = 'https://www.instagram.com/sobhanizd'

onMounted(() => {
  // Automatically open Instagram in a new tab
  window.open(instagramUrl, '_blank', 'noopener,noreferrer')
})
</script>

